import React, { useEffect, useState } from "react";
import axios from "axios";
import "./WebinarPage.css";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// 🔥 NEXT TUE / THU 5PM
const getNextWebinarDate = () => {
  const now = new Date();

  const nextDate = new Date(now);

  // Thursday = 4
  const daysUntilThursday = (4 - nextDate.getDay() + 7) % 7;

  nextDate.setDate(nextDate.getDate() + daysUntilThursday);

  // 5:00 PM
  nextDate.setHours(17, 0, 0, 0);

  // If today is Thursday after 5 PM, schedule next Thursday
  if (nextDate <= now) {
    nextDate.setDate(nextDate.getDate() + 7);
  }

  return nextDate;
};

// Generate a mock transaction ID like: 6a72ee7ecb4d2540925...
const generateTransactionId = () => {
  const chars = "abcdef0123456789";
  let id = "";
  for (let i = 0; i < 20; i++) {
    id += chars[Math.floor(Math.random() * chars.length)];
  }
  return id;
};

// 🔥 Google Calendar link generator (used by "Add to calendar" button)
const getGoogleCalendarLink = (date) => {
  const start = new Date(date);
  const end = new Date(date.getTime() + 90 * 60 * 1000); // 90 mins webinar

  const fmt = (d) =>
    d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: "FYP Ignite — Free Live Webinar",
    dates: `${fmt(start)}/${fmt(end)}`,
    details:
      "A free live session on reaction speed, anticipation & focus with Vevek S., Founder of ForgeYourPeak. Zoom link will be sent to your email.",
    location: "Online — Zoom",
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

const testimonials = [
  {
    id: "aushik",
    name: "Aushik Srinivas",
    level: "Ranji Trophy & TNPL",
    sport: "Cricketer",
    photoUrl: "/testimonials/aushik.png",
    quote:
      "“Vevek is one of the better mentors around for improving your game holistically; he changed the way I trained and performed.”",
  },
  {
    id: "aadityaB",
    name: "Aaditya B",
    level: "TNPL & 1st Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/aaditya.png",
    quote:
      "“I was wearing glasses while playing before, the program helped me remove dependancy on my glasses forever!”",
  },
  {
    id: "mihir",
    name: "Mihir Ravi",
    level: "TNPL & 1st Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/mihir.png",
    quote:
      "“You can ask Vevek anything about training and performance, he is very helpful and responsive.”",
  },
  {
    id: "aniroudh",
    name: "Aniroudh Baskaran",
    level: "2nd Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/aniroudh.png",
    quote:
      "“I have been using Vevek's training program for over 3 years now and it has completely transformed my game.”",
  },
  {
    id: "ashwintg",
    name: "Ashwin Narayanan TG",
    level: "3rd Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/ashwin.png",
    quote:
      "“We have been using Vevek's approach for warm up, visualization and in-game routines, it works really well for us!”",
  },
  {
    id: "rajiv",
    name: "Rajiv Rangabhasyam",
    level: "1st Division TNCA",
    sport: "Cricketer",
    photoUrl: "/testimonials/rajiv.png",
    quote:
      "“I was able to spot the ball better after the program, highly recommended for all athletes”",
  },
];

const FAQ_ITEMS = [
  {
    q: "Is this really free? Is there a catch?",
    a: "Yes, this session is completely free.",
  },
  {
    q: "Will there be a recording?",
    a: "No recording is sent out afterwards — the session is live on Zoom only, so it's best to join live if you can.",
  },
  {
    q: "Is this only for cricketers?",
    a: "No. Vision, timing, memory, anticipation, and recovery are trainable systems behind any fast-reaction sport — cricket, tennis, boxing, badminton, and more.",
  },
  {
    q: "Do I need special equipment?",
    a: "No equipment is needed to attend the webinar — just a device with Zoom. The Ignite program itself is designed to work with minimal equipment.",
  },
];

// 🔥 QUIZ STEPS 1-4 (step 5 is the name/email/phone form, handled separately)
const QUIZ_STEPS = [
 {
  key: "sport",
  question: "What sport do you play?",
  options: [
    "Cricket",
    "Football",
    "Racquet sports",
    "Other",
  ],
},
  {
    key: "hardest",
    question: "What feels hardest right now?",
    options: [
      "Reacting quickly",
      "Staying focused",
      "Anticipating play",
      "Making decisions under pressure",
      "Recovering consistently",
    ],
  },
  {
    key: "improve",
    question: "What would you most like to improve?",
    options: [
      "Reaction speed",
      "Visual clarity",
      "Timing and anticipation",
      "Confidence under pressure",
    ],
  },
  {
    key: "coach",
    question: "Do you currently work with a coach?",
    options: ["Yes, regularly", "Sometimes", "Not currently"],
  },
];

const TOTAL_QUIZ_STEPS = QUIZ_STEPS.length + 1; // +1 for the final name/email/phone step

const WebinarPage = () => {
  useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, []);
  useEffect(() => {
      const navbar = document.querySelector("header, .navbar");
      const footer = document.querySelector("footer");
  
      if (navbar) navbar.style.display = "none";
      if (footer) footer.style.display = "none";
  
      return () => {
        if (navbar) navbar.style.display = "";
        if (footer) footer.style.display = "";
      };
    }, []);
  useEffect(() => {
    const hideWidget = () => {
      // 🔥 ElevenLabs widget remove
      document.querySelectorAll("elevenlabs-convai").forEach((el) => el.remove());

      // 🔥 also remove injected containers
      document
        .querySelectorAll("iframe, [class*='convai'], [id*='convai']")
        .forEach((el) => el.remove());
    };

    hideWidget();

    const interval = setInterval(hideWidget, 500);

    return () => clearInterval(interval);
  }, []);

  const [webinarAvailable, setWebinarAvailable] = useState(null);
  const [targetDate, setTargetDate] = useState(getNextWebinarDate());
  const [countdown, setCountdown] = useState("");
  const [weekCount, setWeekCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState("");
  const [registeredName, setRegisteredName] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [whatsappLink, setWhatsappLink] = useState("");
  const seatsLeft = Math.max(0, 16 - weekCount);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  // 🔥 QUIZ POPUP STATE
  const [quizOpen, setQuizOpen] = useState(false);
  const [quizStep, setQuizStep] = useState(1); // 1..4 = questions, 5 = final form
  const [quizAnswers, setQuizAnswers] = useState({});

  const openQuiz = () => {
  setQuizStep(1);
  setQuizAnswers({});
  setQuizOpen(true);
};
  const closeQuiz = () => {
    setQuizOpen(false);
  };

  const handleQuizSelect = (key, value) => {
    setQuizAnswers((prev) => ({ ...prev, [key]: value }));
  };

 const goToNextQuizStep = () => {

  // Question steps 1-4
  if (quizStep <= QUIZ_STEPS.length) {

    const currentQuestion =
      QUIZ_STEPS[quizStep - 1];

    const selectedAnswer =
      quizAnswers[currentQuestion.key];

    // Answer select பண்ணவில்லை
    if (!selectedAnswer) {
      return;
    }
  }

  setQuizStep((s) =>
    Math.min(
      s + 1,
      TOTAL_QUIZ_STEPS
    )
  );
};
  // new: FAQ accordion (open item index), doesn't touch registration logic
  const [openFaq, setOpenFaq] = useState(0);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  // Check whether the Ignite webinar offer is active.
  // Active offer => show the existing webinar page; inactive/not found => show unavailable message.
  useEffect(() => {
    let isMounted = true;

    const checkWebinarAvailability = async () => {
      try {
        const response = await axios.get("/api/offers/ignite_webinar");
        if (isMounted) {
          setWebinarAvailable(
            response.data?.success === true &&
              response.data?.offer?.isActive === true
          );
        }
      } catch (error) {
        if (isMounted) {
          setWebinarAvailable(false);
        }
      }
    };

    checkWebinarAvailability();

    return () => {
      isMounted = false;
    };
  }, []);

  // 🔥 countdown
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        setTargetDate(getNextWebinarDate());
        return;
      }

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);

      setCountdown(`${d}d ${h}h ${m}m ${s}s`);
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  // 🔥 weekly count
  useEffect(() => {
    const fetchCount = async () => {
      try {
        const res = await axios.get("/api/webinar-users/week-count");
        setWeekCount(res.data.count);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCount();

    const interval = setInterval(fetchCount, 5000);

    return () => clearInterval(interval);
  }, []);

  // WhatsApp community invite link
  useEffect(() => {
    const loadWhatsappLink = async () => {
      try {
        const res = await axios.get("/api/webinar-settings");
        setWhatsappLink(res.data.igniteWhatsappLink || "");
      } catch (err) {
        console.log(err);
      }
    };

    loadWhatsappLink();
  }, []);

  // Auto-redirect to WhatsApp community after success
  useEffect(() => {
    if (registered && whatsappLink) {
      const waTimer = setTimeout(() => {
        window.location.replace(whatsappLink);
      }, 1000);

      return () => clearTimeout(waTimer);
    }
  }, [registered, whatsappLink]);

  // Lock page scroll while overlay/quiz is open
  useEffect(() => {
    document.body.style.overflow = loading || registered || quizOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [loading, registered, quizOpen]);

  // 🔥 form change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // 🔥 submit (same logic as before — now triggered from the quiz's final step)
  const handleSubmit = async (e) => {
     if (e) {
    e.preventDefault();
  }

    try {
      setLoading(true);
      setQuizOpen(false); // hide quiz so the loading overlay is visible
      const getCookie = (name) => {
      const match = document.cookie.match(
          new RegExp("(^| )" + name + "=([^;]+)")
        );

        return match ? match[2] : null;
      };

      const fbp = getCookie("_fbp");
      const fbc = getCookie("_fbc");
            const registrationResponse =
        await axios.post("/api/webinar-register", {
          ...formData,
          ...quizAnswers, // 🔥 extra profiling data from the quiz, optional on the backend
          webinarDate: targetDate,

          // 🔥 Meta attribution
          metaFbp: fbp,
          metaFbc: fbc,
          metaUserAgent: navigator.userAgent,
        });

      const metaLeadEventId =
        registrationResponse.data.metaLeadEventId;

      if (window.fbq) {

        // =========================================
        // LEAD EVENT
        // =========================================

        window.fbq(
          "trackSingle",
          "2060088607979588",
          "Lead",
          {
            content_category: "Webinar Registration",
            content_name: "FYP Ignite Webinar",
            value: 0,
            currency: "INR",
          },
          {
            eventID: metaLeadEventId,
          }
        );


        // =========================================
        // CLEAN VALUE FOR EVENT NAME
        // =========================================

        const clean = (str) =>
          String(str || "")
            .replace(/[^a-zA-Z0-9]/g, "_")
            .substring(0, 40);


        // =========================================
        // SPORT
        // =========================================

        if (quizAnswers.sport) {

          window.fbq(
            "trackSingle",
            "2060088607979588",
            "Sport_" + clean(quizAnswers.sport)
          );

        }


        // =========================================
        // HARDEST
        // =========================================

        if (quizAnswers.hardest) {

          window.fbq(
            "trackSingle",
            "2060088607979588",
            "Hardest_" + clean(quizAnswers.hardest)
          );

        }


        // =========================================
        // IMPROVE
        // =========================================

        if (quizAnswers.improve) {

          window.fbq(
            "trackSingle",
            "2060088607979588",
            "Improve_" + clean(quizAnswers.improve)
          );

        }


        // =========================================
        // COACH
        // =========================================

        if (quizAnswers.coach) {

          window.fbq(
            "trackSingle",
            "2060088607979588",
            "Coach_" + clean(quizAnswers.coach)
          );

        }

      }

      setRegisteredEmail(formData.email);
      setRegisteredName(formData.name);
      setTransactionId(generateTransactionId());

      setTimeout(() => {
        setLoading(false);
        setRegistered(true);
      });
    } catch (error) {
      setLoading(false);
      setQuizOpen(true); // let them retry from the same step
      alert(error.response?.data?.error || "Registration Failed");
    }
  };

  const dateLabel = targetDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const dateShort = targetDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
  });

  const dayLabel = targetDate.toLocaleDateString("en-GB", { weekday: "short" });

  const currentQuestion = QUIZ_STEPS[quizStep - 1]; // undefined on step 5

  if (webinarAvailable === null) {
    return (
      <div className="ignite-page webinar-status-page">
        <div className="webinar-status-card" role="status" aria-live="polite">
          <h1>Checking Webinar Availability...</h1>
          <p>Please wait a moment.</p>
        </div>
      </div>
    );
  }

  if (!webinarAvailable) {
    return (
      <div className="ignite-page webinar-status-page">
        <div className="webinar-status-card">
          <h1>No Upcoming Webinar</h1>
          <p>
            There is currently no webinar scheduled. Please check back soon
            for upcoming sessions.
          </p>
        </div>
      </div>
    );
  }

  return (
  <div className="ignite-page">

    {/* =====================================================
        FULLSCREEN LOADING
    ====================================================== */}
    {loading && (
      <div className="page-fullscreen-overlay">
        <div className="loading-screen">
          <div className="loader-circle">
            <div className="loader-ring"></div>
          </div>

          <h2 className="loading-title">
            Reserving Your Seat...
          </h2>

          <p className="loading-subtitle">
            Please wait while we reserve your webinar seat.
          </p>
        </div>
      </div>
    )}

    {/* =====================================================
        SUCCESS RECEIPT
    ====================================================== */}
    {registered && !loading && (
      <div className="page-fullscreen-overlay">
        <div className="receipt-success">

          <div className="receipt-header">
            <div className="receipt-check">✓</div>

            <h2>Registration Successful</h2>

            <h3>₹ 0</h3>
          </div>

          <div className="receipt-zigzag">
            {Array.from({ length: 22 }).map((_, i) => (
              <span key={i}></span>
            ))}
          </div>

          <div className="receipt-body">

            <div className="receipt-row">
              <span>Transaction ID</span>
              <strong>{transactionId}</strong>
            </div>

            <div className="receipt-row">
              <span>Service</span>
              <strong>FYP Ignite - Webinar</strong>
            </div>

            <div className="receipt-row">
              <span>Registration Method</span>
              <strong>Free Registration</strong>
            </div>

            <div className="receipt-row">
              <span>Registration Time</span>

              <strong>
                {new Date().toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })}
                <br />

                {new Date().toLocaleTimeString("en-US", {
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                })}
              </strong>
            </div>

            <div className="receipt-divider"></div>

            <h4 className="billing-title">
              Billing Details
            </h4>

            <div className="billing-item">
              <strong>{registeredName}</strong>
            </div>

            <div className="billing-item">
              {registeredEmail}
            </div>

            <div className="billing-item">
              {formData.phone}
            </div>
          </div>

          <p className="receipt-note">
            Redirecting you to our WhatsApp community...
          </p>

        </div>
      </div>
    )}

    {/* =====================================================
        QUIZ POPUP
    ====================================================== */}
    {quizOpen && !loading && !registered && (
      <div
        className="quiz-overlay"
        onClick={closeQuiz}
      >

        <div
          className="quiz-modal"
          onClick={(e) => e.stopPropagation()}
        >

          <button
            className="quiz-close"
            onClick={closeQuiz}
            aria-label="Close"
          >
            ×
          </button>

          {currentQuestion ? (
            <>
              <div className="quiz-step-label">
                QUESTION {quizStep} OF {TOTAL_QUIZ_STEPS}
              </div>

              <h2 className="quiz-question">
                {currentQuestion.question}
              </h2>

              <div className="quiz-select-wrap">

                <select
                  value={quizAnswers[currentQuestion.key]}
                  onChange={(e) =>
                    handleQuizSelect(
                      currentQuestion.key,
                      e.target.value
                    )
                  }
                >

                  <option value="">
                    Select one
                  </option>

                  {currentQuestion.options.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}

                </select>

              </div>

              <button
                className="quiz-continue"
                disabled={!quizAnswers[currentQuestion.key]}
                onClick={goToNextQuizStep}
              >
                CONTINUE
                <span className="quiz-arrow">
                  ↗
                </span>
              </button>
            </>
          ) : (
            <>
              <div className="quiz-step-label">
                QUESTION {TOTAL_QUIZ_STEPS} OF {TOTAL_QUIZ_STEPS}
              </div>

              <h2 className="quiz-question">
                Where should we send your seat?
              </h2>

              <form
                onSubmit={handleSubmit}
                className="quiz-final-form"
              >

                <label className="quiz-label">
                  YOUR NAME
                </label>

                <input
                  name="name"
                  className="quiz-input"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />

                <label className="quiz-label">
                  EMAIL
                </label>

                <input
                  name="email"
                  type="email"
                  className="quiz-input"
                  placeholder="you@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <label className="quiz-label">
                  WHATSAPP NUMBER
                </label>

                <div className="quiz-phone-group">

                  <PhoneInput
                    country={"in"}
                    value={formData.phone}
                    onChange={(phone) =>
                      setFormData({
                        ...formData,
                        phone,
                      })
                    }
                    enableSearch={true}
                    searchPlaceholder="Search country..."
                    placeholder="Enter phone number"
                    inputProps={{
                      name: "phone",
                      required: true,
                    }}
                  />

                </div>

                <button
                  type="submit"
                  className="quiz-submit"
                >
                  <span className="quiz-strike">
                    ₹1,299
                  </span>

                  FREE

                  <span className="quiz-arrow">
                    ↗
                  </span>
                </button>

              </form>

              <p className="quiz-fine">
                Joining details will be sent to your WhatsApp.
              </p>
            </>
          )}

        </div>
      </div>
    )}

    {/* =====================================================
        HEADER
    ====================================================== */}
    <header className="site-header">

      <div className="ignite-wrap">

        <div className="brand">
          The Athlete Advantage
        </div>

        <nav className="header-nav">

          <a href="#question">
            Why it matters
          </a>

          <a href="#framework">
            The framework
          </a>

          <a href="#host">
            Your host
          </a>

          <button
            className="header-reserve"
            onClick={openQuiz}
          >
            Reserve your seat ↗
          </button>

        </nav>

      </div>

    </header>


    {/* =====================================================
        HERO
    ====================================================== */}
    <section className="hero">

      <div className="ignite-wrap hero-grid">

        {/* LEFT */}
        <div className="hero-content">

          <div className="hero-eyebrow">
            FREE LIVE MASTERCLASS FOR ATHLETES
          </div>

          <h1>
            HOW FAST
            <br />

            <span>CAN YOU</span>

            <br />

            <span>SEE?</span>
          </h1>

          <p className="sub">
            Discover the hidden visual skills behind reaction,
            timing, anticipation and decision-making — and learn
            how they can be measured and trained.
          </p>

          <div className="cta-row">

            <button
              className="btn btn-primary"
              onClick={openQuiz}
            >
              <span className="old-price">
                ₹1,299
              </span>

              <span>
                FREE
              </span>

              <span>
                ↗
              </span>
            </button>

            <a
              href={getGoogleCalendarLink(targetDate)}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost"
            >
              Add to calendar
            </a>

          </div>

          <div className="hero-date">

            <span>
              {targetDate
                .toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })
                .toUpperCase()}
            </span>

            <span className="date-dot"></span>

            <span>
              5:00 PM IST
            </span>

            <span className="date-dot"></span>

            <span>
              LIVE ONLINE
            </span>

          </div>

        </div>


       {/* RIGHT IMAGE */}

        <div className="hero-image-wrap">

            <img
                src="/Hero/webinarhero.png"
                alt="Athlete"
                className="hero-image"
            />

        </div>

      </div>

    </section>


    {/* =====================================================
        QUESTION — 45 MS
    ====================================================== */}
    <section
      className="question-section"
      id="question"
    >

      <div className="ignite-wrap question-grid">

        <div className="question-left">

          <span className="section-eyebrow">
            THE QUESTION
          </span>

          <p>
            Your performance has a
            <br />
            <em>visual starting point.</em>
          </p>

        </div>

        <div className="question-right">

          <div className="vertical-line"></div>

          <div>

            <h2>
              45 ms.
            </h2>

            <p>
              That's the gap between
              <br />
              good and exceptional.
            </p>

          </div>

        </div>

      </div>

    </section>


    {/* =====================================================
        WATCH THE BALL
    ====================================================== */}
    <section className="watch-section">

      <div className="ignite-wrap watch-grid">

        <div className="watch-image">

          <img
            src="/Hero/cricket.jpeg"
            alt="Cricket performance"
          />

        </div>

        <div className="watch-content">

          <span className="section-eyebrow">
            EVERY COACH SAYS:
          </span>

          <h2>
            “WATCH
            <br />
            <em>THE BALL.</em>”
          </h2>

          <p className="watch-main">
            But nobody teaches you how.
          </p>

          <p>
            Seeing the ball isn't one skill.
            It involves visual clarity, attention,
            processing, anticipation, decision-making
            and reaction.
          </p>

          <strong>
            That's what IGNITE measures.
          </strong>

        </div>

      </div>

    </section>


    {/* =====================================================
        FRAMEWORK
    ====================================================== */}
    <section
      className="framework-section"
      id="framework"
    >

      <div className="ignite-wrap">

        <span className="section-eyebrow">
          THE IGNITE FRAMEWORK
        </span>

        <h2 className="framework-title">
          The system behind
          <br />
          <em>your performance.</em>
        </h2>

        <div className="framework-list">

          <div className="framework-row">
            <span>01</span>
            <strong>SEE.</strong>
            <p>Receive the information.</p>
          </div>

          <div className="framework-row">
            <span>02</span>
            <strong>PROCESS.</strong>
            <p>Understand what you're seeing.</p>
          </div>

          <div className="framework-row">
            <span>03</span>
            <strong>DECIDE.</strong>
            <p>Choose the response.</p>
          </div>

          <div className="framework-row">
            <span>04</span>
            <strong>ACT.</strong>
            <p>Execute.</p>
          </div>

          <div className="framework-row">
            <span>05</span>
            <strong>RECOVER.</strong>
            <p>Prepare for what comes next.</p>
          </div>

        </div>

      </div>

    </section>


    {/* =====================================================
        PERFORMANCE ASSESSMENT
    ====================================================== */}
    <section className="assessment-section">

      <div className="ignite-wrap">

        <span className="section-eyebrow">
          PERFORMANCE ASSESSMENT
        </span>

        <h2 className="assessment-title">
          Numbers make the
          <br />
          <em>invisible visible.</em>
        </h2>

        <div className="assessment-grid">

          <div className="assessment-item">

            <span>
              REACTION
            </span>

            <strong>
              245 ms
            </strong>

            <p>
              How quickly you respond
            </p>

          </div>

          <div className="assessment-item">

            <span>
              DECISION
            </span>

            <strong>
              320 ms
            </strong>

            <p>
              How quickly you choose
            </p>

          </div>

          <div className="assessment-item">

            <span>
              ANTICIPATION
            </span>

            <strong>
              82%
            </strong>

            <p>
              How well you read ahead
            </p>

          </div>

          <div className="assessment-item">

            <span>
              VISUAL ACUITY
            </span>

            <strong>
              6/4.5
            </strong>

            <p>
              How clearly you see
            </p>

          </div>

        </div>

      </div>

    </section>


    {/* =====================================================
        HOST
    ====================================================== */}
    <section
      className="host-section"
      id="host"
    >

      <div className="ignite-wrap host-grid-new">

        <div className="host-copy">

          <span className="section-eyebrow">
            YOUR HOST
          </span>

          <h2>
            Meet <span className="vevek-name">Vevek</span>
           
          </h2>

          <p className="host-intro">
            An interdisciplinary performance coach
            specializing in vision and cognitive training.
          </p>

          <p>
            ForgeYourPeak applies measurable,
            brain-based methods to real athlete
            performance — helping competitors
            understand the system behind their skill.
          </p>

          <div className="host-tags">

            <span>
              ATHLETE-FIRST
            </span>

            <span>
              MEASUREMENT-LED
            </span>

            <span>
              BUILT FOR SPORT
            </span>

          </div>

        </div>

        <div className="host-image-new">

          <img
            src="/Hero/Vevek-hero.jpeg"
            alt="Vevek S."
          />

        </div>

      </div>

    </section>


    {/* =====================================================
        FAQ
    ====================================================== */}
    <section className="faq-section">

      <div className="ignite-wrap faq-grid">

        <div className="faq-title">

          <span className="section-eyebrow">
            GENTLE ANSWERS
          </span>

          <h2>
            The questions
            <br />
            most athletes
            <br />
            <em>quietly wonder.</em>
          </h2>

        </div>

        <div className="faq-list">

          {FAQ_ITEMS.map((item, i) => (

            <div
              className={`faq-item ${
                openFaq === i ? "open" : ""
              }`}
              key={item.q}
            >

              <button
                className="faq-q"
                onClick={() =>
                  setOpenFaq(
                    openFaq === i ? -1 : i
                  )
                }
              >

                <span>
                  {item.q}
                </span>

                <span className="plus">
                  {openFaq === i ? "⌃" : "⌄"}
                </span>

              </button>

              {openFaq === i && (

                <div className="faq-a">
                  <p>
                    {item.a}
                  </p>
                </div>

              )}

            </div>

          ))}

        </div>

      </div>

    </section>


    {/* =====================================================
        FINAL CTA
    ====================================================== */}
    <section className="final-section">

      <div className="ignite-wrap final-grid">

        <div className="final-copy">

          <span className="section-eyebrow">
            FREE LIVE MASTERCLASS
          </span>

          <h2>
            Know your
            <br />
            numbers.
            <br />

            <em>Then train them.</em>
          </h2>

          <p>
            A focused hour with Vevek S. on reaction,
            timing, anticipation and decision-making
            under pressure.
          </p>

          <div className="final-date">

            <strong>
              {dateLabel.toUpperCase()}
            </strong>

            <span>
              5:00 PM IST
            </span>

            <span>
              LIVE ON ZOOM
            </span>

          </div>

        </div>


        <div className="final-action">

          <p>
            Four quick questions.
            <br />
            One focused
            <br />
            masterclass.
          </p>

          <button
            className="final-register"
            onClick={openQuiz}
          >
            BEGIN QUESTIONNAIRE
            <span>↗</span>
          </button>

          <small>
            No spam. Your answers help us make
            the session more useful.
          </small>

        </div>

      </div>

    </section>


    
   

  </div>
);
};

export default WebinarPage;